var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVoterIdIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_22613",
    "data-name": "Group 22613",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.809,
    height: 30.533,
    viewBox: "0 0 21.809 30.533",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_36001",
    "data-name": "Path 36001",
    d: "M0,15.267Q0,8.521,0,1.775C0,.5.5,0,1.772,0H20.033c1.272,0,1.774.5,1.774,1.772q0,13.492,0,26.984c0,1.272-.5,1.775-1.771,1.776H1.775C.5,30.531,0,30.028,0,28.759q0-6.746,0-13.492m21.264,0q0-6.746,0-13.493c0-1.007-.225-1.227-1.246-1.227q-9.131,0-18.263,0C.78.545.545.777.545,1.74q0,13.527,0,27.053c0,.961.236,1.193,1.212,1.193q9.131,0,18.263,0c1.018,0,1.243-.222,1.244-1.23q0-6.746,0-13.493",
    transform: "translate(0 0.001)",
    fill: "#19242d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36003",
    "data-name": "Path 36003",
    d: "M83.69,76.96a1.256,1.256,0,0,1,.953,1.319q.02,2.96,0,5.92a1.3,1.3,0,0,1-1.363,1.378q-2.993.033-5.987,0a1.3,1.3,0,0,1-1.366-1.445c-.01-1.928-.005-3.856,0-5.783a1.3,1.3,0,0,1,.957-1.387H83.69m-7.222,4.617.2.123c.3-.339.572-.7.89-1.012a1.372,1.372,0,0,1,2.188-.014c.816.784.816.784,1.644-.008a1.378,1.378,0,0,1,2.146-.022c.157.146.262.367.572.423,0-.966.017-1.91-.007-2.852a.78.78,0,0,0-.836-.808q-2.958-.03-5.917,0a.819.819,0,0,0-.874.915c0,1.086,0,2.171,0,3.257m1.387,3.43c1.941,0,3.762.019,5.582-.014.44-.008.649-.383.659-.814.014-.588.011-1.177,0-1.765a2.663,2.663,0,0,0-1.53-1.721.723.723,0,0,0-.628.195c-1.337,1.338-2.665,2.684-4.088,4.12m-1.379-1.649c0,.355,0,.627,0,.9a.56.56,0,0,0,.018.134c.142.553.488.662.882.272.691-.686,1.378-1.377,2.066-2.065.753-.752.75-.749-.037-1.507-.29-.279-.61-.56-1.014-.343A8.585,8.585,0,0,0,76.61,82.4c-.294.287-.079.7-.133.961",
    transform: "translate(-65.566 -66.462)",
    fill: "#1a252e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36004",
    "data-name": "Path 36004",
    d: "M21.3,54.08q-3.914,0-7.827,0a2.11,2.11,0,0,1-.672-.058,1.08,1.08,0,0,1,.221-2.109,10.853,10.853,0,0,1,1.156-.013h14.7c.181,0,.363-.007.544,0A1.1,1.1,0,0,1,30.561,53,1.085,1.085,0,0,1,29.4,54.075c-1.883.014-3.766.005-5.649.005H21.3m-.009-1.636H14.278c-.385,0-.772-.011-1.157.014a.53.53,0,0,0-.025,1.059,3.833,3.833,0,0,0,.543.016H28.958c.159,0,.319.007.476-.008.335-.032.569-.2.559-.557a.522.522,0,0,0-.534-.513,5.276,5.276,0,0,0-.544-.01H21.29",
    transform: "translate(-10.39 -44.81)",
    fill: "#1b262f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36005",
    "data-name": "Path 36005",
    d: "M69.52,16.163c-.2,0-.408-.008-.612,0a.86.86,0,0,1-.935-.525.8.8,0,0,1,.286-.963c.309-.276.283-.553,0-.858-.567-.61-.459-1.113.324-1.448.188-.08.269-.224.4-.336.284-.241.674-.392.919-.112.411.471,1.585.538,1.2,1.353a1.666,1.666,0,0,0,.033,1.967c.241.344-.228.861-.737.912-.292.029-.588.005-.883.005v0m0-.547c.159,0,.317,0,.475,0,.2-.006.439.036.542-.188s-.139-.288-.254-.414a1.307,1.307,0,0,1,.1-1.586c.265-.264.24-.416-.1-.52-.152-.046-.323-.057-.41-.208-.246-.423-.462-.345-.681.023-.076.126-.221.141-.354.176-.383.1-.431.251-.122.545a1.288,1.288,0,0,1,.063,1.586c-.117.125-.347.19-.222.42.1.187.308.161.487.165.158,0,.317,0,.475,0",
    transform: "translate(-58.64 -10.166)",
    fill: "#1c262f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36006",
    "data-name": "Path 36006",
    d: "M14.741,78.053c-.543,0-1.087.017-1.63,0a1.087,1.087,0,1,1-.014-2.173c1.086-.021,2.174-.023,3.26,0a1.085,1.085,0,0,1,.014,2.169c-.542.027-1.086.006-1.63.006M14.7,77.5c.543,0,1.086.013,1.628-.005a.532.532,0,1,0,0-1.064c-1.063-.018-2.126-.014-3.189,0a.537.537,0,1,0,0,1.07c.52.014,1.04,0,1.561,0",
    transform: "translate(-10.356 -65.513)",
    fill: "#1e2831"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36007",
    "data-name": "Path 36007",
    d: "M69.33,156.382c-1.521,0-3.042,0-4.563,0-.232,0-.584.083-.574-.28s.362-.261.593-.261q4.563-.007,9.126,0c.232,0,.584-.083.574.28s-.362.26-.593.261c-1.521.006-3.042,0-4.563,0",
    transform: "translate(-55.437 -134.572)",
    fill: "#1c262f"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36008",
    "data-name": "Path 36008",
    d: "M69.343,179.833c1.521,0,3.042,0,4.563,0,.232,0,.583-.086.584.27s-.35.271-.582.272q-4.563.006-9.126,0c-.232,0-.583.086-.584-.27s.35-.271.582-.272c1.521-.005,3.042,0,4.563,0",
    transform: "translate(-55.441 -155.3)",
    fill: "#1c262f"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36009",
    "data-name": "Path 36009",
    d: "M67.49,167.861c.885,0,1.77,0,2.655,0,.222,0,.512-.036.5.294-.011.269-.27.252-.475.252q-2.757,0-5.514,0c-.222,0-.521.034-.5-.294.023-.312.324-.25.541-.251.93,0,1.861,0,2.791,0",
    transform: "translate(-55.405 -144.962)",
    fill: "#1c262f"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36010",
    "data-name": "Path 36010",
    d: "M67.08,192.41H64.561c-.213,0-.446-.014-.432-.3.012-.228.219-.251.411-.251h5.106c.213,0,.454.016.431.3s-.272.251-.478.251H67.08",
    transform: "translate(-55.382 -165.691)",
    fill: "#1c262f"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36011",
    "data-name": "Path 36011",
    d: "M67.124,203.855h2.519c.213,0,.447.014.432.3-.012.227-.219.251-.411.251H64.558c-.213,0-.454-.016-.431-.3s.272-.251.478-.251h2.519",
    transform: "translate(-55.379 -176.048)",
    fill: "#1c262f"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36012",
    "data-name": "Path 36012",
    d: "M21.714,156.44c-.408,0-.816,0-1.224,0-.177,0-.335-.058-.352-.241-.021-.233.153-.3.357-.3.839,0,1.678,0,2.517,0,.177,0,.335.058.352.241.021.233-.153.3-.357.3-.431,0-.862,0-1.292,0",
    transform: "translate(-17.39 -134.63)",
    fill: "#1c2730"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36013",
    "data-name": "Path 36013",
    d: "M21.783,180.425c-.431,0-.862,0-1.292,0-.177,0-.335-.058-.352-.241-.021-.233.153-.3.356-.3.839,0,1.678,0,2.517,0,.177,0,.336.058.352.241.021.232-.153.3-.356.3-.408,0-.816,0-1.224,0",
    transform: "translate(-17.39 -155.345)",
    fill: "#1c2730"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36014",
    "data-name": "Path 36014",
    d: "M21.714,192.428c-.431,0-.862.005-1.292,0-.18,0-.312-.1-.293-.294a.264.264,0,0,1,.282-.239c.884,0,1.769,0,2.653,0,.179,0,.316.1.293.294s-.173.245-.35.244c-.431,0-.862,0-1.292,0Z",
    transform: "translate(-17.381 -165.716)",
    fill: "#1c2730"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36015",
    "data-name": "Path 36015",
    d: "M21.752,204.415c-.431,0-.862,0-1.292,0-.176,0-.322-.075-.325-.267s.144-.27.319-.271q1.292,0,2.585,0c.175,0,.323.074.325.266s-.143.27-.32.272c-.431,0-.862,0-1.292,0",
    transform: "translate(-17.389 -176.064)",
    fill: "#1c2730"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36016",
    "data-name": "Path 36016",
    d: "M89.777,76.242H82.97a.9.9,0,0,1,.521-.114h5.764a.9.9,0,0,1,.521.114",
    transform: "translate(-71.653 -65.744)",
    fill: "#333c44"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36017",
    "data-name": "Path 36017",
    d: "M79.924,84.311c0-1.085,0-2.171,0-3.257a.819.819,0,0,1,.874-.915q2.958-.029,5.917,0a.78.78,0,0,1,.836.808c.024.942.007,1.886.007,2.852-.309-.056-.414-.277-.572-.423a1.378,1.378,0,0,0-2.146.022c-.828.792-.828.792-1.644.008a1.373,1.373,0,0,0-2.188.014c-.317.316-.594.673-.89,1.012l-.2-.123m4.117-3.662a1.088,1.088,0,1,0,1.061,1.1,1.1,1.1,0,0,0-1.061-1.1",
    transform: "translate(-69.021 -69.197)",
    fill: "#82e3e4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36018",
    "data-name": "Path 36018",
    d: "M90.1,108.589c1.423-1.436,2.751-2.782,4.088-4.12a.723.723,0,0,1,.628-.194A2.663,2.663,0,0,1,96.345,106c.006.588.01,1.177,0,1.765-.01.432-.219.806-.659.814-1.82.033-3.641.014-5.582.014",
    transform: "translate(-77.809 -90.044)",
    fill: "#82e3e4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36019",
    "data-name": "Path 36019",
    d: "M79.827,106.851c.055-.265-.161-.674.133-.961a8.585,8.585,0,0,1,1.783-1.65c.4-.216.724.064,1.014.343.786.758.789.755.037,1.507-.689.689-1.375,1.379-2.066,2.065-.393.39-.74.281-.882-.272a.561.561,0,0,1-.018-.134c0-.272,0-.543,0-.9",
    transform: "translate(-68.916 -89.957)",
    fill: "#82e3e4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36020",
    "data-name": "Path 36020",
    d: "M24.853,55.95h7.625a5.275,5.275,0,0,1,.544.01.522.522,0,0,1,.534.513c.01.356-.225.525-.559.557-.158.015-.318.008-.476.008H17.2a3.834,3.834,0,0,1-.543-.016.53.53,0,0,1,.025-1.059c.384-.025.771-.013,1.157-.014h7.012",
    transform: "translate(-13.953 -48.316)",
    fill: "#82e3e4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36021",
    "data-name": "Path 36021",
    d: "M73.416,19.682c-.158,0-.317,0-.475,0-.179,0-.385.021-.487-.165-.126-.23.1-.3.222-.421a1.288,1.288,0,0,0-.063-1.586c-.308-.294-.261-.445.122-.545.133-.035.278-.05.354-.176.22-.367.435-.446.681-.023.088.15.258.162.41.208.344.1.369.256.1.52a1.307,1.307,0,0,0-.1,1.586c.115.126.357.187.254.414s-.341.181-.542.188c-.158,0-.317,0-.475,0",
    transform: "translate(-62.533 -14.232)",
    fill: "#82e3e4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36022",
    "data-name": "Path 36022",
    d: "M18.312,81.035c-.52,0-1.041.011-1.561,0a.537.537,0,1,1,0-1.07c1.063-.011,2.126-.014,3.189,0a.532.532,0,1,1,0,1.064c-.542.018-1.085,0-1.628.006",
    transform: "translate(-13.968 -69.046)",
    fill: "#82e3e4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36023",
    "data-name": "Path 36023",
    d: "M103.059,83.963a1.088,1.088,0,1,1-1.113,1.044,1.094,1.094,0,0,1,1.113-1.044m.519,1.063c-.06-.329-.248-.54-.6-.508a.493.493,0,0,0-.482.55.5.5,0,0,0,.585.515.528.528,0,0,0,.493-.557",
    transform: "translate(-88.04 -72.509)",
    fill: "#1a2835"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6305",
    "data-name": "Rectangle 6305",
    width: 21.808,
    height: 30.533,
    transform: "translate(0 0.001)",
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoterIdIcon);
export default __webpack_public_path__ + "static/media/VoterIdIcon.6ce658d50de3f9066d94d45e465b1de6.svg";
export { ForwardRef as ReactComponent };